import React from 'react';
import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];
const REVEAL_VIEWPORT = { once: true, margin: '-80px' };
const STAGGER_VIEWPORT = { once: true, margin: '-60px' };
const REVEAL_TRANSITION = { duration: 0.8, ease: EASE };

const ITEM_VARIANTS = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
};

export const Reveal = ({ children, delay = 0, y = 30, className = '', ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={REVEAL_VIEWPORT}
    transition={{ ...REVEAL_TRANSITION, delay }}
    {...props}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = '', stagger = 0.1, ...props }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="visible"
    viewport={STAGGER_VIEWPORT}
    variants={{ hidden: {}, visible: { transition: { staggerChildren: stagger } } }}
    {...props}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = '', ...props }) => (
  <motion.div className={className} variants={ITEM_VARIANTS} {...props}>
    {children}
  </motion.div>
);
